import { render, staticRenderFns } from "./userset.vue?vue&type=template&id=0a7f5328&"
import script from "./userset.vue?vue&type=script&lang=js&"
export * from "./userset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports